import LoaderFullScreen from '@/components/loader-fullscreen/LoaderFullScreen.vue';
import MaskedField from '@/components/masked-field/MaskedField.vue';
import DropDownConsulte from '@/components/dropdownconsulte/DropDownConsulte.vue';
import RegiaoStatus from '@/components/formulario/RegiaoStatus.vue';
import { corrigirAriaDoMultiselect } from '@/uteis/corrige-aria-multiselect';
import { completarEscalaDeFonteDoWidget } from '@/uteis/escala-fonte-acessibilidade';
import router from '@/routes';
import '@sweetalert2/themes/dark/dark.css';
import '@vueform/multiselect/themes/default.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import { createApp } from 'vue';
import Vue3Lottie from 'vue3-lottie';
import 'vue3-lottie/dist/style.css';
import App from './App.vue';

import setupInterceptors from '@/interceptors/setupInterceptors';
import { store } from '@/store';
import { pt } from 'yup-locale-pt';

import ModalConsulte from '@/components/modal/ModalConsulte.vue';
import ModalFiltroEstudante from '@/components/modal/ModalFiltroEstudante.vue';
import ModalFiltroFuncionario from '@/components/modal/ModalFiltroFuncionario.vue';
import Multiselect from '@vueform/multiselect';
import { QuillEditor } from '@vueup/vue-quill';
import Maska from 'maska';
import * as yup from 'yup';
import './signalr';

import { init as initApm } from '@elastic/apm-rum';
import { setupCalendar } from 'v-calendar';
import VueApexCharts from 'vue3-apexcharts';
//LOGS RUM - REAL USER MONITORING - ELASTIC APM (DESABILITADO EM PRD)
const environment = sessionService.GetEnvironment();
if (environment == 'hml') {
  const apm = initApm({
    serviceName: 'saeweb-vue',
    serverUrl: 'https://42767f795d5c44448f5e344be94d1824.apm.eastus2.azure.elastic-cloud.com:443',
    environment: environment,
    transactionSampleRate: 0.01,
  });

  apm.setCustomContext({
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
  });
}

yup.setLocale(pt);

const app = createApp(App);

app.use(router).use(Maska);
app.use(store).use(Vue3Lottie, { name: 'Vue3Lottie' });

app.use(VueApexCharts);
app.component('ApexChart', VueApexCharts);

/*
 * O `vue-lazyload` SAIU, e não deve voltar.
 *
 * Ele guarda a URL em `data-src` e só a copia para `src` quando julga o elemento visível — e essa
 * decisão sai de `getBoundingClientRect()` reavaliado em eventos de SCROLL e RESIZE da janela.
 * Em toda listagem com foto do sistema a URL assinada do blob chega DEPOIS da primeira
 * renderização; se nesse meio tempo não houver scroll nem resize, nada reavalia e a imagem fica
 * só com `data-src` para sempre. Era o defeito do Painel de Professores em produção — o link da
 * foto estava certo e funcional, e mesmo assim a linha mostrava o texto do `alt`.
 *
 * O adiamento que se queria é o `loading="lazy"` NATIVO do `<img>`: é do navegador, não depende
 * de evento nenhum e funciona dentro de iframe, acordeão, aba escondida e modal. Ver
 * `@/uteis/foto-perfil`, que centraliza o `src` com queda para o avatar padrão.
 */

app.use(setupCalendar, {});

setupInterceptors(store);
app.component('MultiSelect', Multiselect);
app.component('ModalConsulte', ModalConsulte);
app.component('ModalFiltroFuncionario', ModalFiltroFuncionario);
app.component('ModalFiltroEstudante', ModalFiltroEstudante);
app.component('LoaderFullScreen', LoaderFullScreen);
app.component('MaskedField', MaskedField);
/*
 * Registro GLOBAL de propósito. `RegiaoStatus` é a região viva permanente usada para
 * anunciar carregamento e mudança de estado (WCAG 4.1.3); registrá-la aqui faz com que
 * adotá-la numa tela seja uma linha de template, sem `import` nem entrada em
 * `components:` — o que importa porque o padrão errado (`<div v-if role="status">`) está
 * espalhado por dezenas de telas e a barreira de adoção decide se a correção acontece.
 */
app.component('RegiaoStatus', RegiaoStatus);

/*
 * O COMBO PADRÃO do sistema, global pelo mesmo motivo do RegiaoStatus: ele vai substituir os
 * ~240 `<select>` crus espalhados por 109 arquivos, e exigir `import` + entrada em `components:`
 * em cada um seria 109 edições a mais e 109 chances de esquecer uma.
 *
 * Global também é o que sustenta a promessa da migração: com todo combo passando por aqui, um
 * ajuste de acessibilidade, de máscara de erro ou de comportamento é feito em UM arquivo.
 */
app.component('DropDownConsulte', DropDownConsulte);
app.component('QuillEditor', QuillEditor);

app.mount('#app');

/*
 * Correção de um defeito de ARIA do `@vueform/multiselect` (ver o comentário completo em
 * `uteis/corrige-aria-multiselect.ts`): o pacote emite `aria-multiselectable` e
 * `aria-placeholder` no <input> de busca, que não os permite.
 *
 * Depois do `mount` de propósito: a limpeza inicial precisa que os combos da primeira
 * tela já existam no DOM.
 */
corrigirAriaDoMultiselect();

/*
 * Complemento do "Aumentar/Diminuir fonte" do widget Sienna (ver
 * `uteis/escala-fonte-acessibilidade.ts`): ele escala apenas uma lista fechada de elementos,
 * que não inclui rótulo, botão nem campo de formulário, e só no instante do clique — então
 * modal aberto depois nascia sem o ajuste.
 *
 * Depois do `mount`, pela mesma razão do anterior: a primeira aplicação precisa da tela montada.
 */
completarEscalaDeFonteDoWidget();

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import sessionService from './services/helper/session.service';
